export function isIos() {
  const userAgent = navigator.userAgent || '';
  const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent);
  const isIpadOsDesktopMode = navigator.platform === 'MacIntel'
    && navigator.maxTouchPoints > 1;

  return isIosDevice || isIpadOsDesktopMode;
}

export function isStandalonePwa() {
  const displayModeStandalone = window.matchMedia?.('(display-mode: standalone)').matches;
  return displayModeStandalone || navigator.standalone === true;
}
